import React from 'react';
import { ADGMImage, Loading, ADGMModal } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withStyles, Button, Typography } from '@material-ui/core';
import styles from './styles';

const DeleteConditionModal = ({ isOpen, selectedCondition, handleClose, classes, handleSubmit }) => {
  return (
    <ADGMModal open={isOpen} toggleModal={handleClose} onClose={handleClose} className={classes.modal}>
      <div className={classes.innerModalAccept}>
        {false && <Loading />}
        <ADGMImage
          name='cross-icon-black.svg'
          alt='crossicon'
          className={classes.crossIconimg}
          aria-hidden='true'
          onClick={handleClose}
        />
        <Typography variant='h6' component='h1' className={classes.Title}>
          {keyEmptyCheck('remove_term', { s: selectedCondition?.index + 1 })}
        </Typography>
        <Typography variant='h6' component='h2' className={classes.subTitle}>
          {keyEmptyCheck('remove_sure_term')}
        </Typography>
        <div className={classes.buttonSectionDelete}>
          <Button variant='contained' color='primary' className={classes.deleteSubmitButton} onClick={handleSubmit}>
            {keyEmptyCheck('yes')}
          </Button>
        </div>
      </div>
    </ADGMModal>
  );
};
DeleteConditionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectedCondition: PropTypes.object.isRequired,
};
export default withStyles(styles)(injectIntl(DeleteConditionModal));
